import PersonalDetail from "./PersonalDetail";
import EducationClass from "./Education";
import ExperienceClass from "./Experience";
import UploadFileClass from "./UploadFile";
import { Card, CardBody, CardFooter} from "reactstrap";
import { Rating } from "react-simple-star-rating";
import { Btn, H6, Image, P } from "../../../../AbstractElements";
import { Href, JobCancelButton, JobPersonalDetails, JobSubmitButton, JobUIDesigner, JobUploadYourFiles, JobYourEducation, JobYourExperience, Savethisjob } from "../../../../Constant";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Link } from "react-router-dom";

const JobApply = () => {
  return (
    <Card>
      <div className="job-search">
        <CardBody className="pb-0">
          <div className="d-flex">
            <Image width="40" height="40"  className="img-40 b-r-0 img-fluid  m-r-20" src={dynamicImage("job-search/1.jpg")} alt=""/>
            <div className="flex-grow-1">
              <H6 className="f-w-600">
                <Link to={Href}>{JobUIDesigner}</Link>
                <span className="pull-right">
                  <Btn color="primary"><span><i className="fa fa-check text-white" /></span>{Savethisjob}</Btn>
                </span>
              </H6>
              <P>{Savethisjob} <Rating className="rating ms-1" initialValue={Math.random()*5} size={15} /></P>
            </div>
          </div>
          <div className="job-description">
            <H6 className="mb-0">{JobPersonalDetails}</H6>
            <PersonalDetail />
            <H6 className='mb-0'>{JobYourEducation}</H6>
            <EducationClass />
            <H6  className= 'mb-0' >{JobYourExperience}</H6>
            <ExperienceClass />
            <H6 className='mb-0'>{JobUploadYourFiles}</H6>
            <UploadFileClass />
          </div>
        </CardBody>
        <CardFooter>
          <Btn color="primary mx-1">{JobSubmitButton}</Btn>
          <Btn color="light">{JobCancelButton}</Btn>
        </CardFooter>
      </div>
    </Card>
  );
};

export default JobApply;
